import React from 'react';
const CartItemLoader = () => <div className="flex w-full h-auto bg-white dark:bg-zinc-950 py-4 md:py-7 border-b border-neutral-100 dark:border-neutral-800" data-sentry-component="CartItemLoader" data-sentry-source-file="cart-item-loader.tsx">
    <div className="flex-shrink-0 w-24 h-24 md:w-28 md:h-28 bg-neutral-300 dark:bg-neutral-600 rounded-md ltr:mr-4 rtl:ml-4" />
    <div className="flex flex-col w-full overflow-hidden">
      <div className="h-4 bg-neutral-300 dark:bg-neutral-600 rounded w-3/4 mb-2" />
      <div className="h-4 bg-neutral-300 dark:bg-neutral-600 rounded w-1/2 mb-4" />
      <div className="flex items-end justify-between">
        <div className="flex space-x-2">
          <div className="w-8 h-8 bg-neutral-300 dark:bg-neutral-600 rounded" />
          <div className="w-8 h-8 bg-neutral-300 dark:bg-neutral-600 rounded" />
          <div className="w-8 h-8 bg-neutral-300 dark:bg-neutral-600 rounded" />
        </div>
        <div className="h-4 bg-neutral-300 dark:bg-neutral-600 rounded w-16" />
      </div>
    </div>
  </div>;
export default CartItemLoader;